/**
 * Workspace secret v2 extraction utilities.
 *
 * Per spec §1.2 (Icke-mål): no backward compatibility for legacy formats.
 * Only workspace-secret-v2 inputs are supported; legacy {v,r,w} capability
 * format is explicitly rejected.
 */

import { decodeWorkspaceSecretV2, encodeWorkspaceSecretV2 } from './workspaceSecretV2'

/**
 * Extract the readKey from a workspace-secret-v2 string.
 * Returns null for non-v2 input (spec §1.2: no legacy fallback).
 */
export function getReadKey(encoded: string): string | null {
    const secret = decodeWorkspaceSecretV2(encoded)
    if (secret) return secret.readKey
    return null
}

/**
 * Extract the writerSeed from a workspace-secret-v2 string.
 * Returns null for read-only secrets or non-v2 input.
 */
export function getWriteSeed(encoded: string): string | null {
    const secret = decodeWorkspaceSecretV2(encoded)
    if (secret) return secret.writerSeed ?? null
    return null
}

/**
 * Redact write access from a workspace-secret-v2 string.
 * Returns a read-only workspace-secret-v2 (writerSeed removed).
 * For non-v2 input, returns the input unchanged (safe passthrough).
 */
export function redactCapability(encoded: string): string {
    const secret = decodeWorkspaceSecretV2(encoded)
    if (secret) {
        const { writerSeed: _writerSeed, ...readOnlySecret } = secret
        return encodeWorkspaceSecretV2(readOnlySecret)
    }
    return encoded
}
